import {Checkbox, CheckboxOptionType} from '@osui/ui';

const options: CheckboxOptionType[] = [
    {label: '添加CSM默认安全组', value: '', disabled: true},
];

export default function SecurityGroupCheckbox({...props}) {
    return (
        <Checkbox.Group
            options={options}
            {...props}
        />
    );
}
